// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Lcm1a","textBlock":"styles_textBlock__0LENg"};